import { render, staticRenderFns } from "./GestionInterna.vue?vue&type=template&id=2058d85f"
import script from "./GestionInterna.vue?vue&type=script&lang=js"
export * from "./GestionInterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports